export function extractEvmAddresses(account) {
    const accounts = account?.eip155?.embeddedWalletInfo?.user?.accounts;
    return {
        saAddress: accounts?.find(account => account.type === 'smartAccount')?.address,
        eoaAddress: accounts?.find(account => account.type === 'eoa')?.address
    };
}
export function extractEvmAddressFromParams(method, params) {
    if (method === 'eth_sendTransaction' || method === 'wallet_sendCalls') {
        if (Array.isArray(params) && params[0] && typeof params[0] === 'object') {
            return params[0].from ?? null;
        }
        return null;
    }
    if (method === 'personal_sign') {
        if (Array.isArray(params) && typeof params[1] === 'string') {
            return params[1];
        }
        return null;
    }
    if (method === 'eth_signTypedData_v4') {
        if (Array.isArray(params) && typeof params[0] === 'string') {
            return params[0];
        }
        return null;
    }
    if (method === 'wallet_getCapabilities') {
        if (Array.isArray(params) && typeof params[0] === 'string') {
            return params[0];
        }
        return null;
    }
    return null;
}
//# sourceMappingURL=EvmUtils.js.map